<template>
  <div style="position: relative;display:flex;min-height: 110px">
    <quill-editor
      ref="cargoRichTextarea"
      :value="content"
      :disabled="disabled"
      :class="editorClass"
      :options="editorOption"
      @change="onChange"
      @ready="quillReady"
      @blur="handleBlur"
    />
    <span
      v-if="maxCount && showCount"
      class="length-limit"
    >{{ `${(displayLength <= maxCount) ? displayLength : maxCount}/${maxCount}` }}</span>
    <span
      v-else-if="showCount"
      class="length-limit"
    >{{ displayLength }}字</span>
  </div>
</template>
<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import lodash from 'lodash'
// 富文本编辑器
import { quillEditor } from 'vue-quill-editor'
const SBC_CASE = ['，', '。', '–', '、', '‘', '’', '“', '”', '；', '×', '￥', '·', '！', '＃', '＄', '％', '＆', '＇', '（', '）', '＊', '＋', '，', '－', '／',
  '０', '１', '２', '３', '４', '５', '６', '７', '８', '９', '：', '；', '＜', '＝', '＞', '？', '＠', 'Ａ', 'Ｂ', 'Ｃ', 'Ｄ', 'Ｅ', 'Ｆ', 'Ｇ', 'Ｈ', 'Ｉ', 'Ｊ', 'Ｋ', 'Ｌ', 'Ｍ', 'Ｎ', 'Ｏ', 'Ｐ',
  'Ｑ', 'Ｒ', 'Ｓ', 'Ｔ', 'Ｕ', 'Ｖ', 'Ｗ', 'Ｘ', 'Ｙ', 'Ｚ', '［', '］', '＾', '＿', '｀', 'ａ', 'ｂ', 'ｃ', 'ｄ', 'ｅ', 'ｆ', 'ｇ', 'ｈ', 'ｉ', 'ｊ', 'ｋ', 'ｌ', 'ｍ', 'ｎ', 'ｏ', 'ｐ', 'ｑ', 'ｒ',
  'ｓ', 'ｔ', 'ｕ', 'ｖ', 'ｗ', 'ｘ', 'ｙ', 'ｚ', '｛', '｜', '｝', '～', '　', ' ']

/**
 * 半角字符
 */
const DBC_CASE = [',', '.', '-', '/', "'", "'", '"', '"', ';', '*', '$', '`', '!', '#', '$', '%', '&', '"', '(', ')', '*', '+', ',', '-', '/', '0', '1', '2', '3',
  '4', '5', '6', '7', '8', '9', ':', ';', '<', '=', '>', '?', '@', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '[',
  ']', '^', '_', '`', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '{', '|', '}', '~', ' ', ' ']
export default {
  name: 'CargoRichTextarea',
  components: { quillEditor },
  model: { prop: 'value', event: 'change' },
  props: {
    // 值
    value: {
      type: String,
      default: () => ''
    },
    // 只读
    disabled: {
      type: Boolean,
      default: () => false
    },
    // 占位提示符
    placeholder: {
      type: String,
      default: () => ''
    },
    // 最多能输入多少字符
    maxCount: {
      type: Number,
      default: () => 0
    },
    // 超过多少字符文本变色
    warningCount: {
      type: Number,
      default: () => 45
    },
    // 文本变色颜色
    warningColor: {
      type: String,
      default: () => 'red'
    },
    // 超过多少字符自动换行
    textChars: {
      type: Number,
      default: () => 45
    },
    // 是否自动大写
    autoUppercase: {
      type: Boolean,
      default: () => false
    },
    // 字母是否自动转大写
    englishLetterAutoUppercase: {
      type: Boolean,
      default: () => false
    },
    // 是否自动转全角
    autoHalfWord: {
      type: Boolean,
      default: () => false
    },
    singleLine: {
      type: Boolean,
      default: () => false
    },
    showCount: {
      type: Boolean,
      default: () => false
    },
    wrapSymbol: {
      type: String,
      default: () => 'n'
    },
    // 清除 /n /r 操作符
    isTrim: {
      type: Boolean,
      default: () => false
    },
    // 是否禁用回车键（避免换行）
    disableEnter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editor: null,
      curLength: 0,
      content: this.value,
      range: null,
      inputting: false,
      curWrapSymbol: null,
      fromClipboard: '',
      fromClipboardSelection: '',
      text: ''
    }
  },
  computed: {
    editorOption() {
      return {
        modules: {
          toolbar: null,
          keyboard: {
            bindings: {
              tab: {
                key: 9,
                handler: function() {
                  // Handle tab
                  return true
                }
              },
              enter: {
                key: 13,
                handler: () => !this.disableEnter
              }
            }
          }
        },
        placeholder: this.placeholder
      }
    },
    displayLength() {
      return this.curLength >= 1 ? this.curLength - 1 : 0
    },
    editorClass() {
      return ['cargo-rich-textarea', this.singleLine ? 'cargo-rich-textarea-single' : '']
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      // 处理因去除尾部换行导致value改变再次触发this.valueChange问题
      if (oldVal.endsWith('\r') && oldVal === newVal + '\r') {
        return
      }
      this.valueChange(newVal)
    },
    disabled(newVal) {
      if (newVal) {
        this.text = ''
      }
    }
  },
  created() {
    this.curWrapSymbol = this.wrapSymbol === 'n' ? '\n' : '\r'
  },
  beforeDestroy() {
    this.$el.removeEventListener('paste', this.onPaste)
    this.$el.removeEventListener('compositionstart', this.onCompositionStart)
    this.$el.removeEventListener('compositionend', this.onCompositionEnd)
    this.$el.removeEventListener('cut', this.handleCut)
    this.$el.removeEventListener('copy', this.handleCopy)
    this.editor = null
  },
  methods: {
    valueChange(val) {
      if (val !== this.text) {
        this.text = val
      }
      let text = val
      if (this.maxCount !== -1 && this.maxCount && text.length - 1 >= this.maxCount) {
        text = text.substring(0, this.maxCount)
      }
      this.range = this.editor.getSelection()
      this.lineBreak(text)
    },
    onChange: lodash.debounce(function(e) {
      if (this.inputting) {
        return
      }
      const { curWrapSymbol: wrapSymbol } = this
      let text = e.text
      if (this.fromClipboard) {
        const { fromClipboard, fromClipboardSelection } = this
        const start = text.substring(0, fromClipboardSelection.index)
        const end = text.substring(fromClipboardSelection.index + fromClipboardSelection.length, text.length)
        text = start + fromClipboard + end
        this.fromClipboard = ''
      }
      text = text.replace(/(\r\n)|(\n)|(\r)/g, wrapSymbol)
      text = text.replace(/\t/g, '')

      // this.lineBreak(text)

      if (!this.inputting) {
        if (text !== wrapSymbol) {
          if (this.autoUppercase) {
            text = text.toUpperCase()
          } else if (this.englishLetterAutoUppercase) {
            let newText = ''
            for (let i = 0; i < text.length; ++i) {
              let ch = text.charAt(i)
              if (ch >= 'a' && ch <= 'z') {
                ch = ch.toUpperCase()
              }
              newText += ch
            }
            text = newText
          }
          if (this.autoHalfWord) {
            text = this.toCDB(text)
          }
        } else {
          text = ''
        }
      } else {
        text = ''
      }
      this.text = text
      // this.lineBreak(text)
      if (this.isTrim) {
        this.$emit('change', text.trim())
      } else {
        this.$emit('change', text)
      }
    }, 0, {
      'leading': false,
      'trailing': true
    }),
    toCDB(str) {
      if (str) {
        for (let i = 0; i < SBC_CASE.length; i++) {
          const reg = new RegExp(SBC_CASE[i], 'g')
          str = str.replace(reg, DBC_CASE[i])
        }
      }
      return str
    },
    lineBreak(text) {
      const { curWrapSymbol: wrapSymbol } = this
      const ops = []
      text = text.replace(/(\r\n)|(\n)|(\r)/g, wrapSymbol)
      text = text.replace(/\t/g, '')
      const textArr = text.split(wrapSymbol)
      const newArr = []
      textArr.forEach((text, index) => {
        if (text) {
          if (text.length <= this.textChars) {
            this.setBreakText(text, newArr, ops)
          } else {
            this.breakText(text, newArr, ops)
          }
        } else {
          if (index <= textArr.length - 2) {
            newArr.push(wrapSymbol)
            ops.push({ insert: wrapSymbol })
          }
        }
      })
      const autoBreakIndex = []
      let newStr = ''
      newArr.forEach(item => {
        newStr += item
        if (item.length === this.textChars + 1) {
          autoBreakIndex.push(newStr.length)
        }
      })
      if (this.range && textArr.length < newArr.length + 1) {
        if (autoBreakIndex.includes(this.range.index) || (this.range && this.range.index + 1 === text.length && text.length > this.textChars)) {
          this.range.index += newArr.length + 1 - textArr.length
        }
      }
      this.editor.setContents(ops)
      this.curLength = this.editor.getText().length
      if (!this.editor.hasFocus()) {
        return
      }
      if (!this.range || this.range.index === 0) {
        this.$nextTick(() => {
          this.editor.setSelection({ index: newStr.length, length: 0 })
        })
      } else {
        this.$nextTick(() => {
          this.editor.setSelection({ ...this.range })
        })
      }
    },
    onCompositionStart() {
      this.inputStartRange = this.editor.getSelection()
      this.inputting = true
    },
    onCompositionEnd(e) {
      const { inputStartRange: { index, length }} = this
      this.inputting = false
      const start = this.value.substr(0, index)
      const end = this.value.substr(index + length)
      this.onChange({ text: start + e.data + end })
    },
    quillReady(e) {
      this.editor = e
      this.$el.addEventListener('paste', this.onPaste)
      this.$el.addEventListener('compositionstart', this.onCompositionStart)
      this.$el.addEventListener('compositionend', this.onCompositionEnd)
      this.$el.addEventListener('cut', this.handleCut)
      this.$el.addEventListener('copy', this.handleCopy)
      e.clipboard.addMatcher(Node.TEXT_NODE, function(node, delta) {
        return ''
      })
      this.valueChange(this.value)
    },
    onPaste(e) {
      // 禁用状态下，不允许使用复制方法
      if (this.disabled) {
        return
      }
      const oldLength = this.editor.getText().length
      this.fromClipboardSelection = this.editor.selection.savedRange
      this.fromClipboard = e.clipboardData.getData('Text')
      this.onChange({ text: this.value })
      setTimeout(() => {
        const curLength = this.editor.getText().length
        this.fromClipboardSelection.index += (curLength - oldLength)
        this.editor.focus()
      })
    },
    handleCut() {
      const { value } = this
      const range = this.editor.getSelection()
      const textarea = document.createElement('textarea')
      document.body.appendChild(textarea)
      textarea.textContent = value.substring(range.index, range.index + range.length)
      textarea.select()
      if (document.execCommand('cut')) {
        document.execCommand('cut')
      }
      document.body.removeChild(textarea)
      this.onChange({ text: value.substr(0, range.index) + value.substr(range.index + range.length) })
    },
    handleCopy() {
      const { value } = this
      const range = this.editor.getSelection()
      let textarea = document.createElement('textarea')
      document.body.appendChild(textarea)
      textarea.textContent = value.substring(range.index, range.index + range.length)
      textarea.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      document.body.removeChild(textarea)
      textarea = null
      setTimeout(() => {
        this.editor.setSelection(range)
      }, 0)
    },
    breakText(text, newArr, ops) {
      if (this.textChars > 0) {
        const lastIndexOfSpace = text.lastIndexOf(' ', this.textChars)
        let strLeft = ''
        const wrapIndex = lastIndexOfSpace > 0 ? lastIndexOfSpace : this.textChars
        this.setBreakText(text.substring(0, wrapIndex), newArr, ops)
        strLeft = text.substring(wrapIndex).trim()
        if (strLeft.length <= this.textChars) {
          this.setBreakText(strLeft, newArr, ops)
        } else {
          this.breakText(strLeft, newArr, ops)
        }
      } else {
        this.setBreakText(text, newArr, ops)
      }
    },
    setBreakText(text, newArr, ops) {
      const { curWrapSymbol: wrapSymbol } = this
      newArr.push(text + wrapSymbol)
      if (this.warningCount !== -1 && text.length > this.warningCount) {
        ops.push({ insert: text.substring(0, this.warningCount) })
        ops.push({ insert: text.substring(this.warningCount, text.length), attributes: { color: this.warningColor }})
        ops.push({ insert: wrapSymbol })
      } else {
        ops.push({ insert: text })
        ops.push({ insert: wrapSymbol })
      }
    },
    hanldeFormat() {
      if (this.text === '') return
      if (this.text.endsWith('\r') || this.text.endsWith('\n')) {
        this.text = this.text.substring(0, this.text.length - 1)
        this.$emit('change', this.text)
      }
    },
    handleBlur() {
      this.$emit('blur')
    }
  }
}
</script>
<style lang="scss">
@import "~@/styles/element-variables.scss";

.cargo-rich-textarea {
  display: flex;
  &.quill-editor {
    display: flex;
    flex-direction: column;
    flex:1;
    width: 100%;
    .ql-container {
      width: 100%;
      height: 100%;
      font-size: 12px;
      .ql-editor {
        padding: 4px;
        height: 100%;
        overflow-y: auto;
        p {
          width: 100%;
          line-height: 20px;
          word-break: break-all;
          span {
            font-size: 12px
          }
        }
      }

      &.ql-snow {
        border-radius: $--border-radius-base;
        border-color: $--border-color-base;
        background-color: #FFFFFF;

        &.ql-disabled {
          background: #F3F4F5;
          color: $--color-text-primary;
        }
      }
    }
  }
  &-single {
    &.quill-editor {
    .ql-container {
      .ql-editor {
        padding: 5px 5px 5px 5px;
        height: 28px;
        overflow: hidden;
      }
    }
    }
  }
}

.length-limit {
  position: absolute;
  font-size: 12px;
  height: 15px;
  line-height: 15px;
  bottom: 0;
  right: 5px;
}

</style>
